<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.00049 0.999023V2.49902"
      :stroke="color"
      stroke-width="0.75"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.99951 0.999023V2.49902"
      :stroke="color"
      stroke-width="0.75"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.75049 4.54395H10.2505"
      :stroke="color"
      stroke-width="0.75"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.5 4.24902V8.49902C10.5 9.99902 9.75 10.999 8 10.999H4C2.25 10.999 1.5 9.99902 1.5 8.49902V4.24902C1.5 2.74902 2.25 1.74902 4 1.74902H8C9.75 1.74902 10.5 2.74902 10.5 4.24902Z"
      :stroke="color"
      stroke-width="0.75"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.84833 6.85059H7.85282"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.84833 8.35059H7.85282"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.9975 6.85059H6.00199"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.9975 8.35059H6.00199"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.1474 6.85059H4.15189"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.1474 8.35059H4.15189"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconCalendar',
  props: {
    size: {
      type: [Number, String],
      default: 12
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
};
</script>
